import * as React from "react";
import BackLink from "../../../components/atoms/BackLink";
import KarteInterface from "../../../interfaces/KarteInterface";
import StudentInterface from "../../../interfaces/StudentInterface";
import StudentKarteEditForm from "../StudentKarteEditForm";

interface Props {
  student: StudentInterface;
  karte: KarteInterface;
}

const StudentKarteEdit = (props: Props) => {
  const { student, karte } = props;

  return (
    <React.Fragment>
      <BackLink>戻る</BackLink>
      <StudentKarteEditForm student={student} karte={karte} />
    </React.Fragment>
  );
};

export default StudentKarteEdit;
